import { NavItemType } from 'types';
import settings from './settting';
import loans from './loans';
import manualReview from './manualReview';
import ledgerMaster from './ledgerMaster';
import mailTemplate from './mailTemplates';
import breMaster from './breMaster';
import consentMaster from './consentMaster';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [settings, loans, manualReview, ledgerMaster, mailTemplate, breMaster, consentMaster]
};

export default menuItems;
